import React from "react";
import "./purgeContestantsPrepNextFinalistRoundBtn.scss";

const PurgeContestantsPrepNextFinalistRoundBtn = ({
  onClick,
  style = {},
  className = "",
  disabled,
  text,
  icon: IconComponent,
  width,
}) => {
  const dynamicStyle = disabled
    ? { color: "black", cursor: "not-allowed" }
    : { color: "#b03a2e" };

  return (
    <button
      type="button"
      style={{
        width,
        ...dynamicStyle,
        ...style,
      }}
      className={`purge-contestants-prep-next-finalist-round-btn ${className}`}
      onClick={onClick}
      disabled={disabled}
      aria-disabled={disabled ? "true" : "false"}
    >
      {IconComponent && (
        <span className="purge-contestants-prep-next-finalist-round-btn-icon">
          <IconComponent
            fillColor={dynamicStyle.color}
            strokeColor={dynamicStyle.color}
          />
        </span>
      )}
      {text}
    </button>
  );
};

export default PurgeContestantsPrepNextFinalistRoundBtn;
